export default __webpack_public_path__ + "static/media/html.ae51b259.png";